import {subdebug} from '@sanity/cli-core'

export const graphqlDebug = subdebug('graphql')
